import Vue from 'vue';

import { apiPath } from '@/api/constants';

export default Vue.resource(
  `${apiPath}{/version}{/apiName}{/id}{/type}{/action}{/slug}/`,
  {},
  {
    delete: {
      method: 'DELETE',
      params: {
        apiName: 'agents',
      },
    },
    getAgents: {
      method: 'GET',
      params: {
        version: 'v2',
        apiName: 'agents',
      },
    },
    patch: {
      method: 'PATCH',
      params: {
        version: 'v2',
        apiName: 'agents',
      },
    },
    invite: {
      method: 'POST',
      params: {
        type: 'invitation',
        apiName: 'agent',
      },
    },
    resign: {
      method: 'POST',
      params: {
        type: 'resign',
      },
    },
    validateInvitation: {
      method: 'GET',
      params: {
        type: 'invitation',
        action: 'status',
        apiName: 'agent',
      },
    },
    registerAgent: {
      method: 'POST',
      params: {
        type: 'invitation',
        action: 'accept',
        apiName: 'agent',
      },
    },
    getCurrentAgentPreferences: {
      method: 'GET',
      params: {
        version: 'v2',
        apiName: 'agents',
        type: 'current',
        action: 'preferences',
      },
    },
    setCurrentAgentPreferences: {
      method: 'PATCH',
      params: {
        version: 'v2',
        apiName: 'agents',
        type: 'current',
        action: 'preferences',
      },
    },
    getCurrentAgentConfig: {
      method: 'GET',
      params: {
        version: 'v2',
        apiName: 'agents',
        type: 'current',
        action: 'configs',
      },
    },
  },
);
